import VueRouter from 'vue-router';
import EmptyContainer from "@/views/layouts/containers/EmptyContainer.vue";
import PageNotFound from "@/views/pages/errors/PageNotFound.vue";
import SideMenu from "@/views/layouts/SideMenu.vue";
import GuestContainer from "@/views/layouts/containers/GuestContainer.vue";
import RegistrationSetupPage from "@/views/pages/auth/RegistrationSetupPage.vue";
import RegistrationSuperShortPage from "@/views/pages/auth/RegistrationSuperShortPage.vue";

if (window && window.Vue) {
  try {
    window.Vue.use(VueRouter);
  } catch (e) {

  }
}


const routes = [
  {
    path: '/',
    name: 'root',
    component: EmptyContainer, // LoggedContainer,
    props: true,
    redirect: '/finance/payout',
    children: [
      {
        path: 'finance',
        name: 'accounts',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/finance/AccountsPage.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: 'finance/accounts_vue',
        name: 'accounts_vue',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/finance/AccountsPage.vue'),
          sidemenu: SideMenu,
        },
      },
      {
        path: '/profile/update/:type',
        name: '/profile/update/:type',
        // redirect: '/finance/test/index',
        //component: GuestContainer,
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/profile/ProfileUpdateSelect.vue'),
        },
      },
      {
        path: '/profile/update',
        name: '/profile/update',
        // redirect: '/finance/test/index',
        //component: GuestContainer,
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/profile/ProfileUpdateSelect.vue'),
        },
      },

      {
        path: '/finance/payout/:system',
        name: '/finance/payout/:system',
        // redirect: '/finance/test/index',
        //component: GuestContainer,
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/finance/payout/PayoutRequisitesPage.vue'),
        },
      },
      {
        path: '/finance/payout/:system/:document',
        name: '/finance/payout/:system/:document',
        // redirect: '/finance/test/index',
        //component: GuestContainer,
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/finance/payout/PayoutRequisitesPage.vue'),
        },
      },
      {
        path: '/finance/payout/:system/account/:account',
        name: '/finance/payout/:system/account/:account',
        // redirect: '/finance/test/index',
        //component: GuestContainer,
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/finance/payout/PayoutRequisitesPage.vue'),
        },
      },
      {
        path: '/security/googlecode',
        name: '/security/googlecode',
        // redirect: '/finance/test/index',
        //component: GuestContainer,
        components: {
          default: () => import(/* webpackChunkName: "about" */ '../views/pages/security/GooglecodeSettingsPage.vue'),
        },
      },

      {
        path: 'finance/deposit/usdt',
        components: {
          default: () => import(/* webpackChunkName: "merchants" */ '../views/pages/finance/deposit/usdt/DepositUsdtTransferPage.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },

      {
        path: 'finance/deposit/ethereum',
        components: {
          default: () => import(/* webpackChunkName: "merchants" */ '../views/pages/finance/deposit/ethereum/DepositEthereumPage.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },

      {
        path: 'finance/deposit/usdc',
        components: {
          default: () => import(/* webpackChunkName: "merchants" */ '../views/pages/finance/deposit/usdc/DepositUsdcTransferPage.vue'),
          sidemenu: SideMenu,
        },
        children: [

        ],
        meta: {
          guest: true,
        },
      },
    ]
  },
  {
    path: '/reg',
    component: EmptyContainer,
    // GuestContainer,
    children: [
      {
        path: '/',
        name: 'Registration',
        component: RegistrationSetupPage,
        meta: {
          guest: true,
        },
      },
    ],
  },
  {
    path: '/reg-promo',
    component: EmptyContainer,
    // GuestContainer,
    children: [
      {
        path: '/',
        name: 'Registration',
        component: RegistrationSuperShortPage,
        meta: {
          guest: true,
        },
      },
      {
        path: '/reg-promo/:from',
        props: {
          default: (route) => ({ from: route.params.from }),
        },
        name: 'Registration',
        component: RegistrationSuperShortPage,
        meta: {
          guest: true,
        },
      }
      // {
      //   path: '/setup',
      //   name: 'Registration',
      //   component: RegistrationSetupPage,
      //   meta: {
      //     guest: true,
      //   },
      // },
    ],
  },
  {
    path: '*',
    component: PageNotFound
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// router.beforeEach((to, from, next) => {
//   if(to.matched.some(record => record.meta.requiresAuth)) {
//     if (localStorage.getItem('jwt') == null) {
//       next({
//         path: '/login',
//         params: { nextUrl: to.fullPath }
//       })
//     } else {
//       let user = JSON.parse(localStorage.getItem('user') as string)
//       next()
//     }
//   } else if(to.matched.some(record => record.meta.guest)) {
//     if(localStorage.getItem('jwt') == null){
//       next()
//     }
//     else{
//       next({ name: 'userboard'})
//     }
//   }else {
//     next()
//   }
// })
//

export default router;
